import { initSentry } from './errors/sentry';
import { initGlobalStyles } from './styles';

export function initCommon() {
	// ensure that some of the below are lazy
	// if necessary
	initSentry();
	initGlobalStyles();
}
